import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Button } from '@monorepo/nova-ui';
import { useDashboard } from '../../../../../contexts';
import { HeaderDetails } from './header-details';
import { HeaderTitle } from './header-title';
import { MetricList } from './metric-list';

export { MetricSeparator } from './metric-separator';

interface DashboardHeaderInfoProps {
  onOpenSymbolsModal?: () => void;
}

export const DashboardHeaderInfo: FC<DashboardHeaderInfoProps> = ({
  onOpenSymbolsModal,
}) => {
  const { t } = useTranslation(['keyMetrics']);
  const { account, program, accountBalance } = useDashboard();

  if (!account || !program || !accountBalance) {
    return null;
  }

  const symbolsButton = onOpenSymbolsModal ? (
    <Button
      variant="outlined"
      size="sm"
      startIcon={<SystemIcon iconName="Info" size={16} />}
      onClick={onOpenSymbolsModal}
    >
      {t('keyMetrics:supportedSymbols.buttonLabel')}
    </Button>
  ) : undefined;

  return (
    <Stack gap={1}>
      <HeaderTitle />
      <HeaderDetails account={account} />
      <MetricList
        program={program}
        accountMetadata={accountBalance}
        extra={symbolsButton}
      />
      {symbolsButton && (
        <Box sx={{ display: { xs: 'none', lg: 'flex', xl: 'none' } }}>
          {symbolsButton}
        </Box>
      )}
    </Stack>
  );
};
